import {v4} from 'uuid'
import {origo} from '../../utils/helpers/origo'
import {Img} from '../../models/editor/img'
import {useAppDispatch, useAppSelector} from '../../stores/configureStore'
import {
  addImageHistoryItem,
  addImageSelected,
  setAttribute,
} from '../../stores/editor/editor.reducer'
import PhotoDropzone from './PhotoDropzone'
import {selectToolboxTabPanel} from '../../stores/toolbox/toolbox.reducer'
import {ImgMasked} from '../../models/editor/imgMasked'
import {IMG_ADDED} from '../../models/editor/imgHistoryItemAction'
import css from '../../css/photoUpload.module.css'
import services from '../../utils/services'
import {AxiosError} from 'axios'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

export default function PhotoUpload() {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {selectForMasked} = useAppSelector(store => store.toolbox)
  const {printArea} = useAppSelector(store => store.editor)
  const selectForImage = useAppSelector(store =>
    store.editor.images.find(img => img.id === selectForMasked?.id),
  ) as ImgMasked | undefined

  const [isUploading, setIsUploading] = useState(false)

  const onDropHandler = async (files: File[]) => {
    if (!files || files.length === 0) {
      return
    }
    const file = files[0]
    setIsUploading(() => true)
    try {
      const response = await services.uploadImage(file)
      const imageUrl = response.data.url
      if (selectForMasked?.id && selectForImage) {
        const newInside = [...selectForImage.inside]
        newInside[selectForMasked.insideIndex] = {
          ...newInside[selectForMasked.insideIndex],
          url: imageUrl,
          position: origo,
          scale: 1,
        }
        dispatch(
          setAttribute({id: selectForMasked.id, data: {inside: newInside}}),
        )
        dispatch(
          selectToolboxTabPanel({
            tabPanel: 'Edit',
            selectForMasked: selectForMasked,
          }),
        )
      } else {
        const image: Img = {
          id: v4(),
          type: 'url',
          url: imageUrl,
          position: printArea?.position ?? origo,
          inert: false,
          locked: false,
          brightness: 1,
          mirroredX: false,
          mirroredY: false,
          rotation: 0,
          scale: 1,
          filters: {
            inverse: false,
            monochrome: false,
            sepia: false,
          },
        }
        dispatch(addImageSelected({image}))
        dispatch(addImageHistoryItem({item: {img: image, action: IMG_ADDED}}))
      }
    } catch (e) {
      const error = e as AxiosError
      if (error.response?.status === 400) {
        alert(error.response.data)
      }
    }
    setIsUploading(() => false)
  }

  return (
    <div
      className={css.containerWrapper}
      style={
        isUploading
          ? {
              cursor: 'progress',
              filter: 'grayscale(1)',
            }
          : {}
      }>
      <div
        className={css.container}
        style={
          isUploading
            ? {
                pointerEvents: 'none',
              }
            : {}
        }>
        <PhotoDropzone onDrop={onDropHandler} />
        <div
          className={css.pixaBay}
          onClick={() => {
            dispatch(
              selectToolboxTabPanel({
                tabPanel: 'PixaBay',
                selectForMasked: selectForMasked,
              }),
            )
          }}>
          {t('Kép keresése PixaBay-en')}
        </div>
      </div>
    </div>
  )
}
